module.exports = __webpack_public_path__ + "img/7.38aea898.jpg";